import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusResponseFirma: false,
    listFirmas: [],

  },
  mutations: {

    setListFirmas (state, data) {
      state.listFirmas = data
    },
    setResponseFirma (state, data) {
      state.statusResponseFirma = data
    },

  },
  actions: {
    getListFirmas ({ commit }, idCompania = null) {
      const companyId = idCompania || JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      const params = '?IdCompania=' + companyId

      const endpoint = '/getFirmas'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      return axios
        .create()
        .get(url)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setListFirmas', response.data.respuesta.Datos)
            return true
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    insertFirma ({ commit }, data) {
      const formData = new FormData()

      formData.append('IdCompania', data.IdCompania || JSON.parse(atob(localStorage.getItem('uid'))).idcompania)
      formData.append('Firma', data.Firma)
      formData.append('Clave', data.Clave)
      formData.append('VigenciaDesde', data.VigenciaDesde)
      formData.append('VigenciaHasta', data.VigenciaHasta)

      const endpoint = '/add-firma'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      const headers = {
        'Content-Type': 'multipart/form-data',
      }

      axios
        .create(headers)
        .post(url, formData)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setResponseFirma', true)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    setStatusResponse ({ commit }, data) {
      commit('setResponseFirma', data)
    },
    updateAlertaFirma ({ commit }, data) {
      const endpoint = '/updateSignatureAlert'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const payload = {
        IdFirma: data.IdFirma,
        AlertaActiva: data.AlertaActiva,
        DiasVencimientoAlerta: data.DiasVencimientoAlerta,
        DiasRepetirAlerta: data.DiasRepetirAlerta,
        CorreoAlerta: data.CorreoAlerta,
      }

      return axios
        .create()
        .put(url, payload)
        .then(response => {
          if (!response.data.respuesta.Error) {
            return true
          } else {
            throw new Error(response.data.respuesta.Mensaje || 'Error al actualizar la alerta')
          }
        })
        .catch(function (error) {
          throw new Error(error.message || 'Error al actualizar la alerta')
        })
    },
  },
}
